<template>
    <PageWrapper layout="boxed">
        <div class="document bg-gray-900 rounded border-gray-alt2 border max-w-4xl m-auto">
            <h1 class="p-8 dm-sans capitalize text-white text-2xl leading-none">Fulfillment Policy</h1>
            <hr>
            <div class="p-8">
                <p>Last updated: October 13th 2020</p>
                <h2>Delivery Policy</h2>
                <p>Once registration has been completed and payment confirmed, your membership will be immediately activated and you will be eligible for all membership benefits listed on the <a class="accent" href="https://vixory.com/register">membership tier</a> you selected during registration. All memberships are good for the days that you select from date of purchase.  You can manage and change your personal info by visiting your <a class="accent" href="https://vixory.com/account">profile page.</a>  If you encounter a problem during checkout or if you have any questions about your membership, please reach out via email to <a class="accent" href="mailto:info@vixory.com">info@Vixory.com.</a></p>

                <h2>Return and Refund Policy</h2>
                <p>The benefits of each membership are clearly stated on our web site.  Memberships can be upgraded once purchased.  Vixory LLC does not offer a refund policy on memberships all sales are final.</p>

                <h2>Interpretation and Definitions</h2>
                <h3>Interpretation</h3>
                <p>The words of which the initial letter is capitalized have meanings defined under the following conditions. The following definitions shall have the same meaning regardless of whether they appear in singular or in plural.</p>

                <h3>Definitions</h3>
                <p>For the purposes of this Return and Refund Policy:</p>
                <ul>
                    <li>
                        <span class="font-bold">Company</span> (referred to as either “the Company”, “We”, “Us” or “Our” in this Agreement) refers to Vixory LLC, 2733 East Battlefield, Ste. 126, Springfield, Missouri 65804.
                    </li>
                    <li>
                        <span class="font-bold">Goods</span> refer to the service offered for sale on the Service.
                    </li>
                    <li>
                        <span class="font-bold">Orders</span> mean a request by You to purchase Goods from Us.
                    </li>
                    <li>
                        <span class="font-bold">Service</span> refers to the Website.
                    </li>
                    <li>
                        <span class="font-bold">Website</span> refers to Vixory, accessible from <a class="accent" href="https://vixory.com/">https://Vixory.com/</a>
                    </li>
                    <li>
                        <span class="font-bold">You</span> mean’s the individual accessing or using the Service, or the company, or other legal entity on behalf of which such individual is accessing or using the Service, as applicable.
                    </li>
                </ul>

                <h3>Cancellation Policy</h3>
                <p>Because each membership is active at time of payment and some of our benefits become eligible once a membership is purchased, we cannot offer any cancellation policy.</p>
            
                <h3>Conditions for Returns</h3>
                <p>We are not offering or selling any products; therefore, we do not have a return policy.  All sales are final.</p>
            
                <h4>Contact Us</h4>
                <p>If you have any questions about our Returns and Refunds Policy, please contact us:</p>
                <ul>
                    <li>By email: <a class="accent" href="mailto:info@vixory.com">info@Vixory.com</a></li>
                </ul>
                <p>For questions and support, please fill out our contact form or contact us</p>
            </div>
        </div>
    </PageWrapper>
</template>
<script>
export default {
    name:"FullfillmentPolicy"
}
</script>